export default "__VITE_ASSET__B$3Gxxk5__"